// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ed-dialog--wrapper[data-v-6ed7703a]{overflow-y:auto;overflow-x:hidden;padding:15px}", ""]);
// Exports
module.exports = exports;
